import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import './index.css'

import AppRouter from './routers/AppRouter'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { AuthProvidor, msalConfig } from './contexts/AuthContext'

import { LoadingProvidor } from './contexts/LoadingContext'
import { SideNavProvidor } from './contexts/SideNavOpenContext'
import { RecordLockProvidor } from './contexts/RecordLockContext'
import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { ThemeProvider } from '@mui/material/styles'
import { theme } from './utils/theme'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

const msalInstance = new PublicClientApplication(msalConfig)
const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <RecordLockProvidor>
          <QueryClientProvider client={queryClient}>
            <LoadingProvidor>
              <SideNavProvidor>
                <AuthProvidor>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <AppRouter />
                  </LocalizationProvider>
                </AuthProvidor>
              </SideNavProvidor>
            </LoadingProvidor>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </RecordLockProvidor>
      </MsalProvider>
    </ThemeProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
